/** @file Weight-brush settings and paint bone (edited in the Weights panel, read by paintWeights). */
import type { Id } from '@pose2d/format/types';
import { createStore } from 'zustand/vanilla';
import type { BrushSettings } from './paintDab';

/** Brush settings plus the bone painted (null = the edited slot's bone). */
export interface BrushState extends BrushSettings {
  bone: Id | null;
}

/** Add mode, 40 px radius, strength and hardness 0.5, replace value 0.5, auto-normalise on. */
export const brushStore = createStore<BrushState>()(() => ({ mode: 'add', radiusPx: 40, strength: 0.5, hardness: 0.5, value: 0.5, autoNormalize: true, bone: null }));
